<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg ? errorMsg : (innerErrorMessage$ | async)"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <div class="sh-form-group__row">
        <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

        <ng-container slot="action">
            <ng-content select="action"></ng-content>
        </ng-container>
    </div>

    <ng-template #complex>
        <sh-form-text-complex-base
            [formControl]="control"
            [id]="controlId"
            [invalid]="isControlInvalid$ | async"
            [autocomplete]="autocomplete"
            [autocompleteFct]="autocompleteFct"
            [autocompleteDebounce]="autocompleteDebounce"
            [autocompleteLoadingMessage]="autocompleteLoadingMessage"
            [autocompleteNoResultsMessage]="autocompleteNoResultsMessage"
            [autocompleteLockOnInvalid]="autocompleteLockOnInvalid"
            [inOverflownContainer]="inOverflownContainer"
            [placeholder]="placeholder"
            [describeLabelId]="describeLabelId"
            [maxLength]="maxLength"
            [autoFocus]="autoFocus"
            class="sh-form-group__input"
            style="flex-grow: 1"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            [indeterminateMsg]="indeterminateMsg"
            [title]="control.disabled ? disabledMsg : ''"
            (selectedSuggestions)="suggestionsSelected($event)"
            (internalError)="onInternalError($event)"
        >
        </sh-form-text-complex-base>
    </ng-template>
    <ng-template #simple>
        <sh-form-text-base
            [formControl]="control"
            [id]="controlId"
            [invalid]="isControlInvalid$ | async"
            [autocomplete]="autocomplete"
            [autocompleteFct]="autocompleteFct"
            [autocompleteDebounce]="autocompleteDebounce"
            [autocompleteLoadingMessage]="autocompleteLoadingMessage"
            [autocompleteNoResultsMessage]="autocompleteNoResultsMessage"
            [autocompleteLockOnInvalid]="autocompleteLockOnInvalid"
            [autoFocus]="autoFocus"
            [inOverflownContainer]="inOverflownContainer"
            [placeholder]="placeholder"
            [describeLabelId]="describeLabelId"
            [maxLength]="maxLength"
            [title]="control.disabled ? disabledMsg : ''"
            class="sh-form-group__input"
            style="flex-grow: 1"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
            (selectedSuggestions)="suggestionsSelected($event)"
            (internalError)="onInternalError($event)"
        >
        </sh-form-text-base>
    </ng-template>
</sh-form-group>
